var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { IntlProvider } from "react-intl";
import deLocale from './locales/de.json';
import enLocale from './locales/en.json';
var OverwritingIntlProvider = function (props) {
    var _a;
    var frontEndLibraryMessages = {
        'de': deLocale,
        'en': enLocale
    };
    var usedLocale = (_a = props.localeOverwrite) !== null && _a !== void 0 ? _a : 'de';
    var usedMessages = props.messagesOverwrite
        ? __assign(__assign({}, frontEndLibraryMessages[usedLocale]), props.messagesOverwrite) : frontEndLibraryMessages[usedLocale];
    return React.createElement(IntlProvider, { locale: usedLocale, messages: usedMessages }, props.children);
};
export default OverwritingIntlProvider;
//# sourceMappingURL=OverwritingIntlProvider.js.map